import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useGetMenu } from "./hooks/useHome";
import "./styles.scss";
import { useConfigureFooter } from "~hooks/useHelpers";
import { toTestId } from "~services/utils/dataToTestId";

const Home = () => {
  const data = useGetMenu();
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useConfigureFooter({variation: "simpliest"});


  return (
    <>
      <div className="flex items-center justify-center py-5 max-w-6xl mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-3 tb:grid-cols-4 xl:grid-cols-5 gap-[2rem] justify-center">
        {data &&
            data
              .filter((item) => !item.type)
              .map((item, index) => (
              <Link
                to={item.disabled ? "#" : item.route}
                key={index}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                target={item.target}
                data-test-id={`button-${toTestId(item.name)}`}
              >
                <div
                  className={`bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center ${
                    hoveredIndex === index ? "hovered" : ""
                  }`}
                >
                  <div className="flex justify-center">
                    <div className={`${item.isReflex ? "w-[140px] h-[50px]" : "min-w-[80%] max-w-[100px] portrait:max-w-[60px]"} portrait:h-auto flex items-center justify-center text-center card-box__svg`}>
                      {item.icon}
                    </div>
                  </div>
                  <div className="text-center relative portrait:mt-5 mt-8 w-full">
                    <h2 className="text-xl font-semibold mb-2">{item.name}</h2>
                  </div>
                </div>
              </Link>
            ))}
             {data && data.filter((item) => item.type).length > 0 && (
            <Link to="/links-uteis" key="shortcut-card">
              <div className="bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center">
                <div className="flex justify-center">
                  <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                    <svg width="100" height="100" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fill="currentColor"
                        className="custom"
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-13h-2v6h6v-2h-4z"
                      />
                    </svg>
                  </div>
                </div>
                <div className="text-center relative portrait:mt-5 mt-8 w-full">
                  <h2 className="text-xl font-semibold mb-2">Links de apoio</h2>
                </div>
              </div>
            </Link>
          )}
        </div>
      </div>
    </>
  );
};

export default Home;
